/** @format */

import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb, Chain } from '@shared/data-access/interfaces';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@shared/data-access/services';


@Component({
	selector: 'shared-components-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadCrumbsComponent implements OnChanges, OnInit {
	public breadcrumbs: Breadcrumb[] = [];
	public isBreadcrumbClickable = true;
	public isPublicLands = this.chain.chainMarketingIdentifierAbbr === 'pl';
	messageFromHomefield = '';

	@Input()
	public finalLabelOverride: string;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private store: Store,
		private chain: Chain
	) {}

	ngOnInit() {
		this.breadcrumbs = this.buildBreadcrumbs(this.route);
		this.store.select('PERSONAL_INFO').subscribe((personalInfo) => {
			this.isBreadcrumbClickable = !!personalInfo;
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['finalLabelOverride'] && !changes['finalLabelOverride'].isFirstChange()) {
			this.breadcrumbs = this.buildBreadcrumbs(this.route);
		}
	}

	buildBreadcrumbs(route: ActivatedRoute): Breadcrumb[] {
		const breadcrumbs = [];

		let current = route.parent;
		let breadcrumbsLabels: string[] = [];
		let path = '';

		while (current?.snapshot?.data) {
			if (current.snapshot.data.breadcrumb) {
				breadcrumbsLabels = current.snapshot.data.breadcrumb
					.split('|')
					.concat(breadcrumbsLabels);
			}
			current = current.parent;
		}

		if (breadcrumbsLabels.includes('Summary')) {
			this.isBreadcrumbClickable = false;
		}

		for (let i = 0; i < breadcrumbsLabels.length; i++) {
			path += `${breadcrumbsLabels[i].replace(/ /g, '')}/`;
			if (i === breadcrumbsLabels.length - 1) {
				breadcrumbs.push({
					name: this.finalLabelOverride ?? breadcrumbsLabels[i],
					url: path
				});
			} else {
				breadcrumbs.push({ name: breadcrumbsLabels[i], url: path });
			}
		}
		return breadcrumbs;
	}

	trackItem(index: number, item: Breadcrumb) {
		return item.name;
	}

	navigateToRoute(message: string) {
		this.router.navigate([message]);
	}
}
